var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77778 0H4.88889V1.52381H9.77778V0ZM6.51852 9.90476H8.14815V5.33333H6.51852V9.90476ZM13.0615 4.86857L14.2185 3.78667C13.8681 3.3981 13.4852 3.03238 13.0696 2.71238L11.9126 3.79429C10.6496 2.84952 9.06074 2.28571 7.33333 2.28571C3.2837 2.28571 0 5.35619 0 9.14286C0 12.9295 3.27556 16 7.33333 16C11.3911 16 14.6667 12.9295 14.6667 9.14286C14.6667 7.52762 14.0637 6.0419 13.0615 4.86857ZM7.33333 14.4762C4.18 14.4762 1.62963 12.0914 1.62963 9.14286C1.62963 6.19429 4.18 3.80952 7.33333 3.80952C10.4867 3.80952 13.037 6.19429 13.037 9.14286C13.037 12.0914 10.4867 14.4762 7.33333 14.4762Z",
    fill: "#758896"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIcon);
export default __webpack_public_path__ + "static/media/verification-icon.0d28b16f.svg";
export { ForwardRef as ReactComponent };